import { Box, Typography } from "@mui/material";
import UnderLine from "components/common/Underline";

export default function SectionHeader({ title, action }) {
  return (
    <Box mb={2} display="flex" alignItems="flex-end" justifyContent="space-between" flexWrap="wrap" gap={1}>
      <Box>
        <Typography variant="h5">{title}</Typography>
        <UnderLine />
      </Box>
      {action}
    </Box>
  );
}
